import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const ParentCategoriesHeaderContent = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);

  return (
    <Stack
      sx={{
        gap: isDesktop ? '32px' : '40px',
        mb: '67px',
      }}
    >
      <Stack
        sx={{
          gap: '4px',
        }}
      >
        <Typography
          component='h2'
          fontWeight={'600 !important'}
          fontSize={'20px'}
          lineHeight={'24px'}
          textAlign={isDesktop ? 'center' : undefined}
        >
          {dictionary.subtitle}
        </Typography>
        <Typography
          fontWeight={'400 !important'}
          fontSize={'20px'}
          lineHeight={'24px'}
          textAlign={isDesktop ? 'center' : undefined}
        >
          {dictionary.secondSubtitle}
        </Typography>
      </Stack>
    </Stack>
  );
};
